"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

var _react = _interopRequireDefault(require("react"));

var _WfsSearchByPolygonButton = _interopRequireDefault(require("../../../../button/wfs/WfsSearchByPolygonButton/WfsSearchByPolygonButton"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WfsSearchByPolygonMenuBar = function WfsSearchByPolygonMenuBar(_ref) {
  var url = _ref.url,
      layer = _ref.layer,
      map = _ref.map,
      wfsOptions = _ref.wfsOptions;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_WfsSearchByPolygonButton.default, {
    type: "primary",
    url: url,
    map: map,
    vectorLayer: layer,
    wfsOptions: wfsOptions,
    children: "Search by Polygon"
  });
};

var _default = WfsSearchByPolygonMenuBar;
exports.default = _default;